export class Dealer {
    id: number = 0;
    name: string = "";
}
